import React from 'react';
import Error from './Error';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import PreLoader from './PreLoader';
import SearchPopup from './SearchPopup';

const NotFound = () => {

  return (
    <>    
        <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <Error/>
        <Footer />
      </div>
    </>
    );
  }
  
  export default NotFound;